import React from "react";
import Sidebar from '../../../components/layout/navigation/sidebar/DynamicSidebar';
import Header from '../../../components/layout/headers/Header'
import ViewEmployees from '../components/ViewEmployees'

const PriceDetails = () => {
    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="content-body">
                <div className="w-full px-4">
                    <ViewEmployees/>
                </div>
            </div>
        </>
    );
};

export default PriceDetails;
